import React from 'react'

const About = () => {
  return (
    <div name='about' className='w-full h-screen bg-[#230552] text-gray-300 py-[400px]'>
        <div className='flex flex-col justify-center items-center w-full h-full'>
            <div className='max-w-[1000px] w-full grid grid-cols-2 gap-8'>
                <div className='sm:text-right pd-8 pl-4 '>
                    <p className='text-4xl font-bold inline border-b-4 border-blue-600'>
                        About
                    </p>
                </div>
                <div></div>
            </div>
            <div className='max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4'>
                <div className='sm:text-right text-4xl font-bold'>
                    <p>Hi, I am Al-Harith, nice to meet you. Please take a look around.</p>
                </div>
                <div >
                    <p>
                    I am passionate about HR, Programming and Designing. Love to work in optimizing processes, 
                    collaborative work and knowledge sharing. I enjoy solving problems and make solution through programming. 
                    I am a happy person and friendly so take your time in my website and be free to say hi.
                    </p>
                </div>
            </div>
        </div>  
    </div>
  )
}

export default About